<template>
    <div style="margin: 10px">
        <v-form>
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px"
                            >{{ $t(formName) }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                            <v-select 
                                label="Chọn kho"
                                v-model="createItem.warehouseId"
                                v-validate="'required'"
                                :items="lstWarehouse"
                                item-text="categoryName"
                                item-value="categoryId"
                                disabled
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                            <v-text-field
                                type="text"
                                label="Mã quản lý"
                                v-model.trim="createItem.code"
                                name="code"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('code')"
                                :data-vv-as="$t('Mã quản lý')"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                            <v-text-field
                                type="text"
                                :label="$t('Tên tài sản')"
                                v-model.trim="createItem.name"
                                name="name"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('name')"
                                :data-vv-as="$t('Tên tài sản')"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <!-- <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                            <div style="padding: 20px 10px">
                                <v-btn v-if="!isExportReturn" color="primary" @click="showSelectMaterial">
                                    Chọn vật tư
                                </v-btn>
                            </div>
                        </v-flex>
                    </v-layout> -->
                    <v-layout>
                        <v-flex>
                            <table class="lstTable">
                                <tr>
                                    <th width="15%">{{$t('lang.material.materialType')}}</th>
                                    <th width="15%">Tên vật tư</th>
                                    <th width="10%">Đơn vị</th>
                                    <th width="10%">Tồn kho</th>
                                    <th width="10%">Số lượng chọn</th>
                                    <th width="10%">Giá</th>
                                    <th width="15%">Thành tiền</th>
                                </tr>
                                <template v-for="(item, index) in lstMaterial">
                                    <tr :key="'mat'+index">
                                        <td :rowspan="item.row" v-if="item.row != undefined && parseInt(item.row) > 0" style="font-weight: bold">{{item.typeName}}</td>
                                        <td>{{ item.materialName }}</td>
                                        <td style="text-align: center">{{ item.unit }}</td>
                                        <td style="text-align: center">{{ item.inventory | currency }}</td>
                                        <td style="text-align: center">{{ item.price | currency }}</td>
                                        <td style="text-align: center">{{ item.quantity | currency }}</td>
                                        <td style="text-align: center">{{ item.amount | currency }}</td>
                                    </tr>
                                </template>
                                <tr>
                                    <td colspan="5"></td>
                                    <td style="text-align: center">Tổng</td>
                                    <td style="text-align: center">{{ totalMaterialAmount | currency }}</td>
                                </tr>
                            </table>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-tabs
                            v-model="active_tab"
                            slider-color="white"
                            style="padding: 10px 0"
                        >
                            <v-tabs-slider color="#2196F3"></v-tabs-slider>
                            <v-tab v-for="tab of tabs" :key="tab.id">
                                {{ tab.name }}
                            </v-tab>
                        </v-tabs>
                    </v-layout>
                    <v-layout wrap v-if="active_tab==0">
                        <v-flex xs12 sm12 md6>
                            <v-flex xs12>
                                <v-text-field
                                    type="text"
                                    label="Giá trị"
                                    v-model.trim="createItem.value"
                                    name="value"
                                    v-validate="'required'"
                                    maxLength="250"
                                    :error-messages="errors.first('value')"
                                    :data-vv-as="$t('Giá trị')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-select
                                    :items="lstLocation"
                                    :label="$t('Địa điểm sử dụng ban đầu')"
                                    v-model="createItem.locationId"
                                    name="locationId"
                                    item-value="categoryId"
                                    item-text="categoryName"
                                    v-validate="'required'"
                                    :data-vv-as="$t('Địa điểm sử dụng ban đầu')"
                                    :error-messages="errors.first('locationId')"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <v-select
                                    :items="lstDepartment"
                                    :label="$t('Bộ phận sử dụng ban đầu')"
                                    v-model="createItem.departmentId"
                                    name="departmentId"
                                    item-value="deptId"
                                    item-text="deptName"
                                    v-validate="'required'"
                                    :data-vv-as="$t('Bộ phận sử dụng ban đầu')"
                                    :error-messages="errors.first('departmentId')"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <i-datepicker
                                    label="Ngày tăng tài sản"
                                    v-model="createItem.createDate"
                                    name="createDate"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    type="number"
                                    label="Thời gian phân bổ (số ngày)"
                                    v-model.trim="createItem.duration"
                                    name="duration"
                                    min="1"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <i-datepicker
                                    label="Thông tin bảo hành (chọn ngày hết bảo hành)"
                                    v-model="createItem.warrantyDate"
                                    name="warrantyDate"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <v-autocomplete
                                    :items="lstSupplier"
                                    :label="$t('Nhà cung cấp')"
                                    v-model="createItem.supplierId"
                                    item-value="partnerId"
                                    item-text="partnerName"
                                    multiple
                                    clearable
                                />
                            </v-flex>
                            <v-flex xs12>
                                <v-select
                                    :items="lstStatus"
                                    :label="$t('Trạng thái')"
                                    v-model="createItem.status"
                                    name="status"
                                    item-value="value"
                                    item-text="text"
                                    v-validate="'required'"
                                    :data-vv-as="$t('Trạng thái')"
                                    :error-messages="errors.first('status')"
                                />
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap v-else>
                        <v-flex xs12 sm12 md6>
                            <v-flex xs12>
                                <v-text-field
                                    type="text"
                                    label="Model"
                                    v-model.trim="createItem.model"
                                    name="model"
                                    maxLength="250"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    type="text"
                                    label="Thông số kỹ thuật"
                                    v-model.trim="createItem.specifications"
                                    name="specifications"
                                    maxLength="250"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    type="text"
                                    label="Xuất xứ"
                                    v-model.trim="createItem.origin"
                                    name="origin"
                                    maxLength="250"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    type="text"
                                    label="Năm sản xuất"
                                    v-model.trim="createItem.yearManufacture"
                                    name="yearManufacture"
                                    maxLength="250"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    type="text"
                                    label="Phụ kiện theo kèm"
                                    v-model.trim="createItem.accessory"
                                    name="accessory"
                                    maxLength="250"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    type="text"
                                    label="Ghi chú"
                                    v-model.trim="createItem.note"
                                    name="note"
                                    maxLength="250"
                                ></v-text-field>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="onSave" :disabled="loading">
                        {{ $t("lang.common.save") }}
                    </v-btn>
                    <v-btn color="error" @click="onCancel" :disabled="loading">
                        {{ $t("lang.common.cancel") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

        <material-list
            :cDialog="materialDlg"
            @select="onSelectMaterial"
            :lstSelectedMaterial="lstMaterial"
            :materialTypeAllyId="createItem.materialTypeAllyId"
            @closeDialog="closeMaterialListDialog"
            :reload="reload"
        />
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import { cateContants } from "@/constants";
import MaterialList from "./component/MaterialList";
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
    name: "fixed-assets-view",
    components: {CTextboxFloat, IDatepicker, MaterialList },
    data: () => {
        return {
            formName: "Sửa mã quản lý tài sản",
            loading: false,
            cropName: '',
            areaCode: '',
            crop: '',
            lstMaterialType: [],
            lstMaterial: [],
            lstMaterialPrice: [],
            lstWarehouse: [],
            materialDlg: false,
            isExportReturn: false,
            importWh: null,
            importRequestId: 0,
            createItem: {
                userCreateId: '',
                code: '',
                name: '',
                warehouseId: '',
                status: '',
                value: '',
                createDate: '',
                duration: '',
                locationId: '',
                departmentId: '',
                warrantyDate: '',
                supplierId: '',
                model: '',
                specifications: '',
                origin: '',
                yearManufacture: '',
                accessory: '',
                note: '',
            },
            reload:0,
            active_tab: 0,
            tabs: [
                {id: 1, name: 'Thông tin tài sản'},
                {id: 2, name: 'Thông tin phụ'},
            ],
            lstLocation: [],
            lstDepartment: [],
            lstSupplier: [],
            lstStatus: cateContants.fixedAssetsStatus,
            totalMaterialAmount: 0,
            fixedAssetsId: 0,
        };
    },

    created() {
        const queryParam = this.$route.query;
        this.fixedAssetsId = queryParam.fixedAssetsId;
        this.getWarehouse();
        this.getDepartment();
        this.getMaterialType();
        this.getSuppliers();
    },
    
    methods: {
        getFixedAssets(fixedAssetsId) {
            if (fixedAssetsId != -1) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/fixedAssets/search?pageSize=-1&page=-1",
                        {id: fixedAssetsId}
                    )
                    .then((data) => {
                        if (data.items) {
                            const fixedAssets = data.items[0];
                            
                            fixedAssets.createDate = moment(String(fixedAssets.createDate)).format('YYYY-MM-DD');
                            fixedAssets.warrantyDate = moment(String(fixedAssets.warrantyDate)).format('YYYY-MM-DD');

                            if (fixedAssets.supplierId != null && typeof fixedAssets.supplierId == 'string' && fixedAssets.supplierId.length > 0) {
                                const items = [];
                                const uArr = fixedAssets.supplierId.split(",");
                                uArr.forEach((v) => {
                                    items.push(parseInt(v));
                                });
                                fixedAssets.supplierId = items;
                            }

                            this.lstMaterial = JSON.parse(fixedAssets.materialData);
                            this.calcuTotalAmount();
                            this.createItem = fixedAssets;
                            
                            const warehouse = this.lstWarehouse.find((v) => v.categoryId === fixedAssets.warehouseId);
                            if (warehouse != undefined) {
                                this.getLocation(warehouse.parentId);
                            }
                        }
                    });
            }
        },
        setInput(){
            this.lstMaterial = [...this.lstMaterial]
        },
        onCancel() {
            const query = this.$route.query;
            this.$router.push({ path: `/fixedAssets`, query: query });
        },
        onSave() {
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                
                if(this.lstMaterial.length < 1){
                    message.error("Không có vật tư");
                    return;
                }

                const lstMaterial_tmp = this.lstMaterial;
                let rt = true;

                $.each(lstMaterial_tmp, function (k, v) {
                    if (v.quantity <= 0) {
                        message.error("Số lượng vật tư phải lớn hơn 0");
                        rt = false;
                    }
                    if (parseFloat(v.quantity) > parseFloat(v.inventory)) {
                        message.error("Số lượng vật tư không được lớn hơn tồn kho");
                        rt = false;
                    }
                });
                if(!rt){
                    return;
                }
            
                const createItem = this.createItem;
                createItem.materialData = JSON.stringify(lstMaterial_tmp);

                if (createItem.supplierId && createItem.supplierId.length > 0) {
                    createItem.supplierId = createItem.supplierId.join();
                } else{
                    createItem.supplierId = '';
                }
                
                // console.log(createItem);
                // return;
                this.loading = true;
                axios
                    .post(process.env.VUE_APP_API_URL + "/fixedAssets/save", createItem)
                    .then(
                        (data) => {
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.onCancel();
                            } else {
                                message.error(this.$t(data.description));
                            }
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            console.log(error);
                        }
                    );
            });
        },
        getMaterialType() {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE"
            ).then(
                (data) => {
                    if (data.length > 0) {
                        this.lstMaterialType = data;
                    }
                }
            );
        },
        getLocation(parentId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=OFFICE_LOCATION&parentId=" + parentId
            ).then(
                (data) => {
                    if (data.length > 0) {
                        this.lstLocation = data;
                    }
                }
            );
        },
        getDepartment() {
            axios.post(
                process.env.VUE_APP_API_URL + "/department/search?pageSize=-1&page=-1", {}
            ).then(
                (data) => {
                    if (data.items) {
                        this.lstDepartment = data.items;
                    }
                }
            );
        },
        getSuppliers() {
            axios.post(
                process.env.VUE_APP_API_URL + "/partner/suppliers?pageSize=-1&page=-1",
                { status: 1 }
            )
            .then((data) => {
                if (data.items) {
                    this.lstSupplier = data.items;
                }
            });
        },
        reCalculate() {
            console.log(this.lstMaterial);
            for (let i = 0; i < this.lstMaterial.length; i++) {
                this.lstMaterial[i].row = 0;
            }

            //
            // sort by typeId
            //
            this.lstMaterial.sort((o1, o2) => {
                if (o1.typeId == o2.typeId) {
                    return o1.materialName.localeCompare(o2.materialName);
                } else {
                    return o1.typeId - o2.typeId;
                }
            })
            
            for (let j = 0; j < this.lstMaterial.length; j++) {
              this.lstMaterial[j].row = null;
            }
            for (let i = 0; i < this.lstMaterialType.length; i++) {
                this.lstMaterialType[i].count = 0;
                for (let j = 0; j < this.lstMaterial.length; j++) {
                    if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
                        this.lstMaterialType[i].count++;
                    }
                }
                if (this.lstMaterialType[i].count != 0) {
                    for (let j = 0; j < this.lstMaterial.length; j++) {
                        if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
                            this.lstMaterial[j].typeName = this.lstMaterialType[i].categoryName;
                            this.lstMaterial[j].row = this.lstMaterialType[i].count;
                            break;
                        }
                    }
                }
            }
        },
        onSelectMaterial(lstSelectMaterial) {
            for (let j = this.lstMaterial.length-1;j>=0; j--) {
                let bHas = false;
                for (let i = 0; i < lstSelectMaterial.length; i++) {
                    if (this.lstMaterial[j].materialId == lstSelectMaterial[i].materialId) {
                        bHas = true;
                        break;
                    }
                }
                if(!bHas){
                    this.lstMaterial.splice(j);
                }
            }
            for (let i = 0; i < lstSelectMaterial.length; i++) {
                let bHas = false;
                for (let j = 0; j < this.lstMaterial.length; j++) {
                    if (this.lstMaterial[j].materialId == lstSelectMaterial[i].materialId) {
                        bHas = true;
                        break;
                    }
                }
                if (!bHas) {
                    lstSelectMaterial[i].row = "";
                    this.lstMaterial.push(lstSelectMaterial[i]);
                }
            }
            this.reCalculate();
        },
        closeMaterialListDialog() {
            this.materialDlg = false;
        },
        showSelectMaterial() {
            this.materialDlg = true;
        },
        deleteItem(item){
            if(confirm("Bạn có chắc xóa vật tư "+ item.materialName + " khỏi mã quản lý này không?")){
                for(let i = 0; i < this.lstMaterial.length; i++){
                    if(this.lstMaterial[i].materialId == item.materialId){
                        this.lstMaterial.splice(i,1);
                        break;
                    }
                }
                this.reCalculate();
            }
        },
        onInputChange($event) {
            const row = parseInt($event.target.getAttribute("data-row"));
            this.lstMaterial[row].amount = parseFloat($event.target.value) * this.lstMaterial[row].price;
        },
        getWarehouse() {
            axios.post(
                process.env.VUE_APP_API_URL +
                "/category/listByType?type=WAREHOUSE&description=1"
            )
            .then((data) => {
                if (data.length > 0) {
                    this.lstWarehouse = data;
                }

                this.getFixedAssets(this.fixedAssetsId);
            });
        },
        calcuTotalAmount() {
            const totalAmount = this.lstMaterial.reduce((n, {amount}) => n + amount, 0);
            this.totalMaterialAmount = totalAmount;
        },
    },

    destroyed() {},
};
</script>
